module.exports = __webpack_public_path__ + "static/media/marketplace.41d30f42.png";